module.exports = __webpack_public_path__ + "img/xianh.56340f98.png";